import { Row } from 'antd'
import KForm from 'app/components/Modules/Form/_KForm'
import KFormInfo from 'app/components/Modules/Form/KFormInfo'
import KInputText from 'app/components/Modules/Form/KInputText'
import KRadio from 'app/components/Modules/Form/KRadio'
import KTextArea from 'app/components/Modules/Form/KTextArea'
import { FormRecord } from 'app/components/Modules/Form/typing'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { RecordTypeEnum } from 'app/queries'
import { Routes } from 'app/routes/Routes'
import React, { ComponentProps } from 'react'
import { useNavigate } from 'react-router-dom'

import { MemberProps } from '../../convention'

type Props = Partial<ComponentProps<typeof KForm>>

const recordType = RecordTypeEnum.rentalCancel

const RentalCancelForm: React.FC<MemberProps<IRental, Props>> = ({
  member,
  props: { onSuccess, ...others } = {}
}) => {
  const navigate = useNavigate()
  const { getRadioOptions } = ToolBox.useFormTools()
  const options = getRadioOptions({ recordType, attribute: 'canceledReason' })

  const onFormSuccess = (record: IRental) => {
    navigate(Routes.Rental.member(String(member.id)).show)
    onSuccess?.(record)
  }

  return (
    <KForm
      mutationOptions={{
        silentSuccess: true,
        payloadNormalizer: (val: FormRecord) => ({
          ...val,
          canceledReasonDescription: options[val?.canceledReason]
        })
      }}
      recordType={recordType}
      initialFetch={false}
      onSuccess={onFormSuccess}
      layout="vertical"
      initialValues={{ rentalId: member.id }}
      {...others}>
      <Row gutter={[0, 12]}>
        <KCol>
          <KFormInfo />
        </KCol>
        <KCol span={24}>
          <KRadio name="canceledReason" required />
        </KCol>
        <KCol span={24}>
          <KTextArea name="suggestions" />
        </KCol>
        <KInputText hidden name="rentalId" />
      </Row>
    </KForm>
  )
}

export default RentalCancelForm
